<script lang="ts">
    import {
        checkCouponCode, couponErrorMessage,
        couponsPermitted,
        enteredCouponCode,
        enteredEmail, fetchedCoupon,
        isCheckingCoupon
    } from "./state/appState";
    import {tick} from 'svelte'

    async function couponCodeBlurred() {
        await tick()
        await checkCouponCode($enteredCouponCode, $enteredEmail)
    }
</script>

{#if $couponsPermitted}
    <div class="form-group mt-2">
        <label for="couponCode" class="form-label">Coupon Code</label>
        <input type="text" placeholder="Coupon Code" class="form-control" id="couponCode"
               bind:value={$enteredCouponCode} on:blur={couponCodeBlurred}/>
        {#if $couponErrorMessage}
            <div class="invalid-feedback display-visible">{$couponErrorMessage}</div>
        {:else if $isCheckingCoupon}
            <div class="valid-feedback display-visible">Checking coupon...</div>
        {:else if $fetchedCoupon !== null}
            <div class="valid-feedback display-visible">Coupon valid</div>
        {:else}
            <div class="valid-feedback display-visible">&nbsp;</div>
        {/if}
    </div>
{/if}

<style>
    .display-visible {
        display: block;
    }
</style>
